import { render } from "./IconBed.vue?vue&type=template&id=32c2bca1"
import script from "./IconBed.vue?vue&type=script&lang=js"
export * from "./IconBed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__